import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import Loader from 'react-loader-spinner';

class ManageTemplate extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({
        hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false,
        hideScriptIgnore: false, hideDeleteAllPopup: false, hideIncorrectPassword: false
      });
    };
    this.DeletedialogClose = () => {
      this.setState({ hideTextAreaPopup: false });
    };
    this.IncorrectPassworddialogClose = () => {
      this.setState({ hideIncorrectPassword: false });
    };
    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchManageTemplate()
        this.dialogClose();
      }
    }];
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchManageTemplate()
        this.dialogClose();
        this.setState({
          disabled: false
        })
      }
    }];

    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteManageTemplate(this.state.propsId)
        this.setState({ disabled: false })

      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,
          disabled: false
        });
      }
    }];
    this.scriptIgnorebuttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.saveDataByIgnoringScriptApi(this.state.currentProps)
        this.setState({ disabled: false })

      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchManageTemplate();
        this.setState({
          hideScriptIgnore: false,
          disabled: false
        });
      }
    }];

    //for delete success
    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.dialogInstance.hide();
        this.fetchManageTemplate()
        this.setState({ disabled: false })
      }
    }];

    //deleteall
    this.deleteAllButton = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },

      'click': () => {
        this.setState({
          hideDeleteAllPopup: false,
          hideTextAreaPopup: true
        });
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeleteAllPopup: false,
        });
      }
    }];

    //incorrectPasswordButtons
    this.incorrectPasswordButtons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideTextAreaPopup: true,
          hideIncorrectPassword: false

        })
      }
    }];

    //deleteall text confirmation
    this.textAreaConfir = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': () => {
        this.deleteInputValidation()
      }
    }, {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideTextAreaPopup: false,
        });
      }
    }];

    this.state = {
      data: [{
        templateId: '',
        name: '',
        content: '',
        noOfParams: ''
      }],
      hideTextAreaPopup: false,
      hideIncorrectPassword: false,
      hideDeleteAllPopup: false,
      disabled: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      contentEditable: "false",
      showStore: false,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      pageNum: null,
      currentProps: "",
      hideScriptIgnore: false
    }
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
  }

  addRow = (data) => {
    var templateController = this;
    if (templateController.state.pageNum != 0) {
      templateController.setState({ pageNum: 0 })
    }
    this.state.data.unshift({
      templateId: "",
      name: "",
      content: "",
      noOfParams: ""
    });
    this.setState({
      data: this.state.data,
      disabled: true,
    })
  }
  fetchManageTemplate = () => {

    var manageController = this;
    $.ajax({
      url: "/salesdesk-api/whatsapp/templates",
      async: false,
      method: 'GET',
      data: {
        projectId: localStorage.getItem('currentProjectId')
      },
      headers: {

        'Authorization': "Bearer " + localStorage.getItem("access_token"),
        // 'Content-Type': 'application/json'
      },
      success: function (res) {
        if (res.success === true) {
          manageController.state.data = res.result;
          manageController.setState(manageController.state);
        } else {
          manageController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/sales-desk/login";
        }
      }
    });
  }

  saveManageTemplateApi(props, e) {
    props.original.name = document.getElementById("name" + props.index).innerText.trim();
    props.original.content = document.getElementById("content" + props.index).innerText.trim();
    var noOfParams2 = document.getElementById("noOfParams" + props.index).innerText.trim();
    this.state.editedId = "-1";
    this.setState(this.state);
    if (props.original.name == "" || props.original.content == "") {
      this.notifyWarning("Please fill all fields");

    } else {
      var saveData = {
        name: props.original.name,
        content: props.original.content,
        projectId: localStorage.getItem('currentProjectId'),
        noOfParams: noOfParams2
      }
      var addtemplateController = this
      $.ajax({
        url: "/salesdesk-api/whatsapp/template",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': "application/json",

        },
        data: JSON.stringify(saveData),
        success: function (res) {
          if (res.success === true) {
            addtemplateController.notifyAdded();
            addtemplateController.fetchManageTemplate();
            addtemplateController.setState({ disabled: false })
          } else {

            addtemplateController.notifyFailedResponse(res.result);

          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/sales-desk/login";
          }
        }
      })
    }

  }

  updateTemplateApi(props, e) {
    // props.original.approved = document.getElementById('approved' + props.index).checked;
    props.original.name = document.getElementById("name" + props.index).innerText.trim();
    props.original.content = document.getElementById("content" + props.index).innerText.trim();
    var noOfParams2 = document.getElementById("noOfParams" + props.index).innerText.trim();
    var validateResult = this.validateCells(props.original.code)
    if (validateResult == true) {

      var updatedData = {
        templateId: props.original.templateId,
        name: props.original.name,
        content: props.original.content,
        // approved: props.original.approved,
        projectId: props.original.projectId,
        noOfParams: noOfParams2
      };
      var updatedDataController = this
      $.ajax({
        url: "/salesdesk-api/whatsapp/template",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(updatedData),
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updatedDataController.state.editedId = "-1";
            updatedDataController.notifyUpdate();
            updatedDataController.fetchManageTemplate();
          } else {
            updatedDataController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/sales-desk/login";
          }
        }


      })
    }
  }

  makeCelledit(props, e) {
    this.markAsBeingEdited(this.state.data[props.index].templateId);
  }

  markAsBeingEdited(templateId) {
    this.state.editedId = templateId;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  deleteManageTemplate
    = (templateId) => {
      let deleteRowViewController = this.state.data;
      let deleteApiViewController = this;
      var deleteConstructorVariables = this;

      if (templateId == "") {
        deleteApiViewController.setState({ deleteRow: true });
        deleteConstructorVariables.setState({ hideDeletePopup: false });
        deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
        deleteRowViewController.splice(templateId, 1);
      } else {
        $.ajax({
          url: "/salesdesk-api/whatsapp/template/" + templateId,
          async: false,
          method: 'DELETE',
          headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
          success: function (res) {

            if (res.success === true) {

              deleteApiViewController.setState({ deleteRow: true });
              deleteConstructorVariables.setState({ hideDeletePopup: false });
              deleteConstructorVariables.notifyDelete();
              deleteRowViewController.splice(templateId, 1);
            } else {
              deleteRowViewController.notifyError();
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "/sales-desk/login";
            }
          }
        });
      }

      if (this.state.deleteRow) {
        this.state.data.splice(templateId, 1);
      }
      deleteConstructorVariables.fetchManageTemplate();


    }
  notifyError() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center"
    });
  }
  notifyWarning(message) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;{message}
      </b>,
      {
        position: "top-center",
      }
    );
  }


  componentDidMount() {
    setTimeout(() => {
      this.fetchManageTemplate();
    }, 300);
    var thisController = this;
    document.addEventListener("projectChanged", function (event) {

      thisController.fetchManageTemplate();
    });

  }

  validateCells(value) {
    if ((value == "")) {
      this.notifyWarning("Please change the tag field");
      return false;
    }
    else {
      return true;
    }
  }

  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.fetchManageTemplate()
    this.setState({ disabled: false })
  }

  notifyAdded() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg"
      style={{ paddingRight: '0px' }} content="" />
      &nbsp;&nbsp;WhatsApp Template added successfully</b>, {
      position: "top-center",
    });
  }


  notifyUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;WhatsApp Template updated successfully</b>, {
      position: "top-center",
    });
  }

  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;WhatsApp Template deleted successfully</b>, {
      position: "top-center",
    });
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"

    });
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }

  notifyFailedDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });


  }

  notifyDeleteAllSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
        content="" />&nbsp;&nbsp;All Mlts have been deleted Successfully</b>, {
      position: "top-center",
    });

  }
  notifyNodata(response) {
    this.setState({
      hideTextAreaPopup: false
    })
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red"
    });


  }
  deleteInputValidation = () => {
    if (document.getElementById('deleteInputFromUser').value == "Delete" ||
      document.getElementById('deleteInputFromUser').value == "delete" ||
      document.getElementById('deleteInputFromUser').value == "DELETE") {
      document.getElementById('deleteInputFromUser').value = "";
      this.deleteAllMlcdApi();
    }
    else {
      this.setState({
        hideIncorrectPassword: true
      })
    }
  }

  notifyDeleteAllSuccess() {
    toast.dismiss();
    toast(<b>
      <img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
        content="" />&nbsp;&nbsp;WhatsApp Template have been deleted Successfully</b>, {
      position: "top-center",
    });

  }

  handleChangeForLanguage = (event) => {
    this.setState({
      value: event.target.value,
    });
    this.fetchManageTemplate();
  }
  render() {
    const { data } = this.state;
    const columns = [
      {
        Header: () => <b>Name</b>,
        accessor: 'name',
        Cell: props => (
          <div name="name">
            <div className="textarea"
              style={{
                background: 'white', height: "2.7em", resize: 'none',
                paddingLeft: '2px', paddingTop: '6px', width: '98%',
                border: (props.original.templateId == "" || props.original.templateId == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                borderRadius: (props.original.templateId == "") ? '2px' : 'none'
              }}
              id={"name" + props.index}
              contentEditable={!((props.original.templateId == "") ? false :
                props.original.templateId != this.state.editedId) ? "plaintext-only" : false}
            >{props.original.name}
            </div>
          </div>)
      },
      {
        Header: () => <b>Content</b>,
        accessor: 'content',
        Cell: props => (
          <div name="content">
            <div className="textarea"
              style={{
                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                width: '98%',
                border: (props.original.templateId == "" || props.original.templateId == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                borderRadius: (props.original.templateId == "") ? '2px' : 'none'
              }}
              id={"content" + props.index}
              contentEditable={!((props.original.templateId == "") ? false :
                props.original.templateId != this.state.editedId) ? "plaintext-only" : false}
            >{props.original.content}
            </div>
          </div>)
      },

      {
        Header: () => <b>No of parameters</b>,
        accessor: 'noOfParams',
        Cell: props => (
          <div name="noOfParams">
            <div className="textarea"
              style={{
                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                width: '98%',
                border: (props.original.templateId == "" || props.original.templateId == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                borderRadius: (props.original.templateId == "") ? '2px' : 'none'
              }}
              id={"noOfParams" + props.index}
              contentEditable={!((props.original.templateId == "") ? false :
                props.original.templateId != this.state.editedId) ? "plaintext-only" : false}
            >{props.original.noOfParams}
            </div>
          </div>)
      },


      {
        Header: <b>Action</b>,
        accessor: 'action',
        width: 200,
        Cell: props => (
          <div id="action">
            <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px', opacity: props.original.name === "hello_world" ? 0.5 : 1, pointerEvents: props.original.name === "hello_world" ? 'none' : 'auto' }} >
              <img className="img-responsive"
                title={(props.original.templateId == "") ||
                  (this.state.data[props.index].templateId == this.state.editedId) ? 'Save' : 'Edit'}
                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                src={(props.original.templateId == "") ? this.saveImageSrc : ((props.original.templateId != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                onClick={(e) => {
                  (props.original.templateId == "") ? this.saveManageTemplateApi(props, e) : (props.original.templateId == this.state.editedId) ?
                    this.updateTemplateApi(props, e) : this.makeCelledit(props, e);
                }} />
            </button>


            <button style={{
              backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px', opacity: props.original.name === "hello_world" ? 0.5 : 1, pointerEvents: props.original.name === "hello_world" ? 'none' : 'auto'
            }} title="Delete">
              <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                onClick={() => (props.original.templateId) === '' ?
                  this.fetchManageTemplate() :
                  this.setState({
                    hideDeletePopup: true, deletePropIndex: props.index, propsId: props.original.templateId
                  })} /></button>
          </div>), width: 100
      },
    ]
    return (
      <div style={{ marginRight: '1%' }}>
        {/* <Loader
        type="TailSpin" color="#282a65"  height={300} width={50}
        style={{ textAlign: 'center' }} /> */}
        <div style={{ background: "#F9F9FB" }} >
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | BackEnd Api </title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          {/* <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" /> */}
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          {/* <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" /> */}
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          <div className="row" style={{ marginLeft: "15px" }}>
            <div className="col-sm-4" style={{ marginTop: '2px' }} >

            </div>
          </div>

          <div className="row" style={{ marginLeft: '14px' }}>
            <div className="col-sm-5">
              <h6 className="nav-item" style={{ color: '#282a65', marginTop: '15px' }}>
                Manage WhatsApp Template</h6>
            </div>
            {/* ------------------------------------------------------------------------------------------------------------- */}
            <div className="col-sm-5" Align="right">



            </div>


            {/* ---------------------------------------------------------------------------------------------------------- */}
            {/* Add button */}
            <div className="col-sm-2 " style={{ marginTop: '-18px' }}>
              <div className="d-flex flex-row-reverse pt-2">

                <div className="p-2" style={{ marginBottom: '10px' }}>

                  <button className="btn action-button"
                    id="addMsg" title=" Add "
                    onClick={this.state.disabled ? this.notifyWarning("Please fill all the data") : this.addRow}>
                    <img src="assets/images/add_white_24dp.png" />
                  </button>
                  <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                    <img src="./assets/images/refresh_white_24dp.png"></img></button>
                </div>
              </div>
            </div>
          </div>

          <div className="row" style={{ marginLeft: '15px', marginTop: '-15px' }}>
            <div className="col-lg-12 ">
              <div className="card">
                <ReactTable
                  data={data}
                  columns={columns}
                  defaultPageSize={10}
                  pageSizeOptions={[5, 10, 15]}
                  onPageChange={this.onPageChange}
                  page={this.state.pageNum}

                />
              </div>
              <ToastContainer className="Toast-at-center" />
              <DialogComponent width='400px' animationSettings={this.settings}
                header='Ignore Script Language' showCloseIcon={true} buttons={this.scriptIgnorebuttons}
                ref={dialog => this.dialogInstance = dialog}
                visible={this.state.hideScriptIgnore} close={this.dialogClose}>
                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                  content="" />&nbsp;Script doesn't match with the selected language.Do you want to continue to add the script?
                Note: Press 'Yes' to delete or press 'No' to decline.
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</DialogComponent>
              {/*Dialog Component For Deletion Confirmation*/}
              <DialogComponent width='400px' animationSettings={this.settings}
                header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                ref={dialog => this.dialogInstance = dialog}
                visible={this.state.hideDeletePopup} close={this.dialogClose}>
                <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                  content="" />&nbsp;Do you want to delete the WhatsApp Template?
                Note: Press 'Yes' to delete or press 'No' to decline.
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</DialogComponent>
              {/*Dialog Component For  Deletion all Confirmation*/}
              <DialogComponent width='400px' animationSettings={this.settings}
                header='Delete All' showCloseIcon={true} buttons={this.deleteAllButton}
                ref={dialog => this.dialogInstance = dialog}
                visible={this.state.hideDeleteAllPopup} close={this.dialogClose}>
                <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                  content="" />&nbsp;Do you want to delete all the Template ?<br />Note: Press 'Yes' to delete or press 'No' to decline.
              </DialogComponent>
              {/*Dialog Component For  Incorrect Password*/}

              <DialogComponent width='400px' animationSettings={this.settings}
                header='Incorrect Password' showCloseIcon={true} buttons={this.incorrectPasswordButtons}
                ref={dialog => this.dialogInstance = dialog}
                visible={this.state.hideIncorrectPassword} close={this.IncorrectPassworddialogClose}>
                Please type "Delete"
              </DialogComponent>
              {/*Dialog Component For  Delete input confirmation*/}


              <DialogComponent width='400px' animationSettings={this.settings}
                header='Delete Confirmation' showCloseIcon={true} buttons={this.textAreaConfir}
                ref={dialog => this.dialogInstance = dialog}
                visible={this.state.hideTextAreaPopup} close={this.DeletedialogClose}>
                Please type "Delete" for confirmation<input type="text" id="deleteInputFromUser" />
              </DialogComponent>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ManageTemplate;


// WEBPACK FOOTER //
// ./src/sales-desk/projectmgmt/ManageTemplate.js